import { getConfigurationsOnView } from '@/model/draft/getConfigurationsOnView';
import { selectConfigurations } from '@/redux/draft/getters/selectConfigurations';
import { StoreState } from '@/redux/types';
import { getCurrentView } from './getCurrentView';

export function getConfigurationsOnCurrentView(state: StoreState) {
  return getConfigurationsOnView(selectConfigurations(state), getCurrentView(state));
}
